import { render, staticRenderFns } from "./Variant_information.vue?vue&type=template&id=567a32bd&scoped=true"
import script from "./Variant_information.vue?vue&type=script&lang=js"
export * from "./Variant_information.vue?vue&type=script&lang=js"
import style0 from "./Variant_information.vue?vue&type=style&index=0&id=567a32bd&prod&lang=scss&parent=true&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a32bd",
  null
  
)

export default component.exports